import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle'

export const defaultTranslations = {
    pluginName: 'FAQs',
    pluginDescription: 'Add a list of frequently asked questions',
}

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin were not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faQuestionCircle} size="3x" />,
}
